<template xmlns="http://www.w3.org/1999/html">
    <div class="chartWrap">
        <table class="kgr-table kgr-table--striped table-groups kgr-row roles">
            <tbody>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell menu-table-cell">
                        <div class="form-widget">
                            <kgr-dropdown
                                v-model="selectedTimeBaseOption"
                                :label="$t('Zeitbasis')"
                                display="name"
                                :options="timeBaseOption"
                            />
                        </div>
                    </td>
                    <td class="kgr-table__cell menu-table-cell">
                        <div class="form-widget date-picker">
                            <div
                                v-t="'Von'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <kgr-date-picker v-model="dateFrom" />
                        </div>
                    </td>
                    <td class="kgr-table__cell menu-table-cell">
                        <div class="form-widget date-picker">
                            <div
                                v-t="'Bis'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <kgr-date-picker v-model="dateTo" />
                        </div>
                    </td>
                    <td class="kgr-table__cell menu-table-cell">
                        <div
                            v-t="'Anzeige'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <label class="kgr-checkbox">
                            <input
                                v-model="stacked"
                                type="checkbox"
                                class="kgr-checkbox__control"
                            />
                            <span
                                v-t="'Summieren'"
                                class="kgr-checkbox__label"
                            ></span>
                        </label>
                    </td>
                    <td
                        v-if="dataSets"
                        class="kgr-table__cell menu-table-cell"
                    >
                        <div class="form-widget">
                            <div
                                v-t="'Gruppen'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <div class="select-table-wrapper">
                                <table>
                                    <tr
                                        v-for="(dataSet, index) in dataSets"
                                        :key="index"
                                        class="unselectable"
                                        :style="{'background-color': selectedGroupIndexes.has(index) ? '#3399FF': '#FFFFFF'}"
                                        @click="updateGroupSelection(index, dataSet.generalInformation)"
                                    >
                                        <template v-if="typeof dataSet.generalInformation === 'undefined'">
                                            <td
                                                disabled="true"
                                                style="font-weight: var(--kgr-font-weight-bold)"
                                            >
                                                {{ dataSet }}
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td>{{ dataSet.generalInformation.name }}</td>
                                            <td
                                                :style="{'background-color': dataSet.generalInformation.color}"
                                                class="select-color"
                                            ></td>
                                        </template>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </td>
                    <td
                        v-if="metadata"
                        class="kgr-table__cell menu-table-cell"
                    >
                        <div class="form-widget">
                            <div class="kgr-inputGroup__label">
                                Werte
                            </div>
                            <div class="select-table-wrapper">
                                <table>
                                    <tr
                                        v-for="(dataSet, key, index) in metadata"
                                        :key="index"
                                        :style="{'background-color': selectedValueKeys.has(key) ? '#3399FF': '#FFFFFF'}"
                                        @click="updateValueSelection(key, dataSet.translation)"
                                    >
                                        <template v-if="typeof dataSet.translation === 'undefined'">
                                            <td
                                                disabled="true"
                                                style="font-weight: var(--kgr-font-weight-bold)"
                                            >
                                                {{ dataSet }}
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td>{{ dataSet.translation }}</td>
                                            <td
                                                :style="{'background-color': dataSet.color}"
                                                class="select-color"
                                            ></td>
                                        </template>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="selectedValueKeys.size > 0 && selectedGroupIndexes.size > 0">
            <UtilisationChart
                v-if="dataSets"
                :data="dataSets"
                :stacked="stacked"
                :metadata="metadata"
                :selected-time-base-option-value="selectedTimeBaseOption.value"
                :selected-value-keys="selectedValueKeys"
                :selected-group-indexes="selectedGroupIndexes"
                css-classes="chart"
            />
        </div>
    </div>
</template>

<script>
import { add, format, getYear, isBefore, isMatch, isValid, parse, sub } from '@legacy/js/date/date-fns.js'
import DatePicker from '../common/form/picker/DatePicker';
import Dropdown from '../common/form/select/Dropdown';
import UtilisationChart from './charts/UtilizationChart';
import UtilizationRepository from '../../js/repository/UtilizationRepository';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-dropdown': Dropdown,
        UtilisationChart
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            metadata: null,
            dataSets: null,

            selectedGroupIndexes: new Set(),
            selectedValueKeys: new Set(),

            stacked: false,
            dateFrom: null,
            dateTo: null,

            timeBaseOption : [
                {name: this.$t('Täglich'), value:'daily'},
                {name: this.$t('Stündlich'), value:'hourly'},
            ],
            selectedTimeBaseOption: null
        }
    },
    watch: {
        dateFrom: function() {
            this.fetchData();
        },
        dateTo: function() {
            this.fetchData();
        },
        selectedTimeBaseOption: function() {
            this.fetchData();
        }
    },
    mounted()  {
        this.selectedTimeBaseOption = this.timeBaseOption[0];
        this.dateFrom = format(sub(new Date(), {days: 3}), 'dd.MM.yyyy');
        this.dateTo = format(add(new Date(), {days: 3}), 'dd.MM.yyyy');
        this.fetchData();
    },
    methods: {
        fetchData() {
            if (!this.dateFrom || !this.dateTo || !this.selectedTimeBaseOption) {
                return;
            }
            if (!isMatch(this.dateFrom, 'dd.MM.yyyy') || !isMatch(this.dateTo, 'dd.MM.yyyy')) {
                return;
            }
            const dateFrom = parse(this.dateFrom, 'dd.MM.yyyy', new Date());
            const dateTo = parse(this.dateTo, 'dd.MM.yyyy', new Date());
            if (!isValid(dateFrom) || !isValid(dateTo) || getYear(dateFrom) < 1000 || getYear(dateTo) < 1000) {
                return;
            }
            if (isBefore(dateTo, dateFrom)) {
                return;
            }
            UtilizationRepository.generate(this.kindergartenId, this.selectedTimeBaseOption.value, this.dateFrom, this.dateTo)
                .then(utilization => {
                    this.metadata = utilization.metaData;
                    this.dataSets = utilization.data;
                    this.sort();
                    this.selectedValueKeys = new Set(Object.entries(this.metadata).map((val) => val[0]).filter((key) => this.selectedValueKeys.has(key)));
                });
        },
        updateValueSelection(key, translation) {
            if(typeof translation !== 'undefined') {
                let selectedValueKeys = new Set(this.selectedValueKeys);
                if(selectedValueKeys.has(key)) {
                    selectedValueKeys.delete(key);
                } else {
                    selectedValueKeys.add(key);
                }
                this.selectedValueKeys = selectedValueKeys;
            }
        },
        updateGroupSelection(index, generalInformation) {
            if(typeof generalInformation !== 'undefined') {
                let selectedGroups = new Set(this.selectedGroupIndexes);
                if (selectedGroups.has(index)) {
                    selectedGroups.delete(index);
                } else {
                    selectedGroups.add(index);
                }
                this.selectedGroupIndexes = selectedGroups;
            }
        },
        sort() {
            let newDataSet = [];
            newDataSet.push(this.dataSets[0]);

            const group_type_regular = this.dataSets.filter(dataSet => dataSet.generalInformation.groupType === 'regular');
            if (group_type_regular.length > 0) {
                newDataSet.push(this.$t('Regelgruppen'));
                newDataSet = newDataSet.concat(group_type_regular);
            }

            const group_type_work = this.dataSets.filter(dataSet => dataSet.generalInformation.groupType === 'work');
            if (group_type_work.length > 0) {
                newDataSet.push(this.$t('Arbeitsgruppen'));
                newDataSet = newDataSet.concat(group_type_work);
            }

            const group_type_plan = this.dataSets.filter(dataSet => dataSet.generalInformation.groupType === 'plan');
            if (group_type_plan.length > 0) {
                newDataSet.push(this.$t('Plangruppen'));
                newDataSet = newDataSet.concat(group_type_plan);
            }

            const group_type_stat = this.dataSets.filter(dataSet => dataSet.generalInformation.groupType === 'stat');
            if (group_type_stat.length > 0) {
                newDataSet.push(this.$t('Auswertungsgruppen'));
                newDataSet = newDataSet.concat(group_type_stat);
            }

            const group_type_misc = this.dataSets.filter(dataSet => dataSet.generalInformation.groupType === 'misc');
            if (group_type_misc.length > 0) {
                newDataSet.push(this.$t('Sonstiges'));
                newDataSet = newDataSet.concat(group_type_misc);
            }

            this.dataSets = newDataSet;
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    td.menu-table-cell {
        vertical-align: top;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        div.select-table-wrapper {
            height: 110px;
            overflow-y: scroll;
            border: solid 2px #d3d6db;
            white-space: nowrap;
            td.select-color {
                width: 25px;
            }
        }
    }
</style>
